import { createContext, useContext } from 'react';
export const WalletContext = createContext(null);
export function useWalletContext() {
    const ctx = useContext(WalletContext);
    if (!ctx) {
        throw new Error('useWalletContext must be used within a <TrainProvider>');
    }
    return ctx;
}
/** Non-throwing version — returns null when used outside TrainProvider */
export function useWalletContextOptional() {
    return useContext(WalletContext);
}
